// extracted by mini-css-extract-plugin
module.exports = {"container":"ThankYouPage_container__a8gv8","heading":"ThankYouPage_heading__HmwYM","subheading":"ThankYouPage_subheading__V_Ay1","button":"ThankYouPage_button__vURiv"};